import React, { useState } from "react"
import { Typography, Grid, Box, Paper, Divider, Toolbar } from "@mui/material"
import { motion, AnimatePresence } from "framer-motion"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import useMediaQuery from "@mui/material/useMediaQuery"

const getConversionColor = (value) => {
  if (value <= 39) return "#FF4D4F" // RED
  if (value <= 49) return "#FAAD14" // YELLOW
  if (value <= 59) return "#52C41A" // GREEN
  return "#1890FF" // BLUE (60+)
}

const Tile = ({ title, value, icon, children, expandable = false, isCircular = false, color, isAmount = false, fullWidthParent = false, secondary }) => {
  const [open, setOpen] = useState(false)
  const [hover, setHover] = useState(false)
  const isTablet = useMediaQuery("(max-width:876px)")

  const expanded = open || hover

  return (
    <Grid
      size={{
        xs: fullWidthParent ? (expanded ? 12 : children ? 12 : 6) : expanded ? 12 : children ? 12 : 6,
        sm: fullWidthParent ? (expanded ? 12 : children ? 8 : 4) : expanded ? 12 : children ? 12 : 6,
        md: fullWidthParent ? (expanded ? 6 : children ? 6 : 3) : expanded ? 12 : children ? 6 : 4,
        lg: fullWidthParent ? (expanded ? 4 : children ? 4 : 2) : expanded ? 8 : children ? 6 : 4,
        xl: fullWidthParent ? (expanded ? 6 : children ? 3 : 2) : expanded ? 6 : children ? 4 : 2,
      }}
    >
      <motion.div
        layout
        // onMouseEnter={() => expandable && setHover(true)}
        // onMouseLeave={() => expandable && setHover(false)}
        onClick={() => expandable && setOpen(!open)}
        style={{ cursor: expandable ? "pointer" : "default" }}
        whileHover={{ scale: expandable ? 1.02 : 1 }}
        // whileHover={{ scale: expandable ? 1.02 : 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
      >
        <Paper
          sx={{
            height: children && expanded && isTablet ? "" : 80,
            p: 1,
            borderRadius: 4,
            display: "flex",
            flexDirection: expanded ? (isTablet && children ? "column" : "row") : "column",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "linear-gradient(135deg, #f2f6ff, #ffffff)",
            boxShadow: expanded ? "0 12px 28px rgba(0,0,0,0.22)" : "0 4px 12px rgba(0,0,0,0.1)",
            border: expanded ? "2px solid #5468FF" : "2px solid rgba(0,0,0,0.15)",
            transition: "all 0.3s ease-in-out",

            "&:hover": {
              boxShadow: "0 12px 28px rgba(0,0,0,0.25)",
              border: "2px solid #5468FF",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: expandable && secondary ? "row" : "column", flex: 2, textAlign: "center", justifyContent: "center", alignItems: "center" }}>
            <Toolbar sx={{ minHeight: "20px !important", gap: "10px", alignItems: "center", justifyContent: "center" }}>
              {icon}
              <Typography variant="subtitle2" sx={{ color: "#5468FF", fontWeight: 600 }}>
                {title}
              </Typography>
            </Toolbar>

            {isCircular ? (
              <Box sx={{ width: 60, height: 60 }}>
                <CircularProgressbar
                  value={value}
                  text={`${value || 0}%`}
                  // styles={buildStyles({ pathColor: "#4e79ff", textColor: "#0d1b3d", trailColor: "#e0e0e0" })}
                  styles={buildStyles({
                    pathColor: getConversionColor(value || 0),
                    textColor: "#0d1b3d",
                    trailColor: "#e0e0e0",
                  })}
                />
              </Box>
            ) : (
              <Typography variant="h5" sx={{ fontWeight: 700, color: !!color || "" }}>
                {isAmount ? `$ ${value?.toFixed(2) || 0}` : value || 0}
              </Typography>
            )}
          </Box>

          {expandable && secondary ? secondary() : <></>}

          {!expandable && children}

          {expandable && (
            <motion.div
              layout
              style={{
                flex: expanded ? 4 : 0,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              {expanded && children && (
                <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }} transition={{ duration: 0.5 }} style={{ flex: 1 }}>
                  <Divider orientation="vertical" sx={{ mx: 2 }} />

                  {children}

                  {/* Helper text when closed */}
                </motion.div>
              )}
            </motion.div>
          )}

          {expandable && !expanded && (
            <Typography variant="caption" sx={{ display: "block", opacity: 0.6, mt: 0.5, fontStyle: "italic" }}>
              Click to expand →
            </Typography>
          )}
        </Paper>
      </motion.div>
    </Grid>
  )
}

export default Tile
